import { Component, Input,ElementRef,ViewChild,Output,EventEmitter } from '@angular/core';
import { GridBaseCase } from '../../grid/grid.base.case';
import {ActivatedRoute} from '@angular/router';
import { Platform } from '@ionic/angular';
import { MapclientServiceService } from '../../../../service/mapclient.service.service';
import { MessageclientService } from '../../../../service/messageclient.service';
import { HttpCustomerService } from '../../../../service/httpcustomer.service';
import {BaseModal} from '../../../../model/base';
import {WebParameterContext} from '../../../../model/common';
import { AppPageElement } from 'src/model/xmlconfig/app.page.element';
import { AppPageElementType } from 'src/model';
import { CommonService } from 'src/service/common.service';
import { BaseCase } from 'src/app/basecase';
declare var app;
@Component({
  selector: 'app-mz-storemaps',
  templateUrl: './mz-storemaps.component.html',
  styleUrls: ['./mz-storemaps.component.scss']
})
export class MzStoremapsComponent extends GridBaseCase {
  @ViewChild('nearbystoremap') map_container:ElementRef;
  @Input() data: any;//接收父组件的值
  dataConfig:AppPageElement = new AppPageElement();
  stats:boolean = false;
  @Output() private childOuterEvent = new EventEmitter();
  dataArrayList: Array<any> = [];
  constructor(
    private platform:Platform,
    private activaRouter: ActivatedRoute,
    private map:MapclientServiceService,
    private msg:MessageclientService,
    private http: HttpCustomerService,
    public base:BaseModal,
    public com: CommonService,
    public baseService:BaseCase
  ) {super(); }

  ngOnChanges(){
    // console.log("505"+this.data);
    
    }
    getCoordInate(el){
      console.log(el);
    }
  LoadData() {
    let that = this;
    console.log(11111);
    that.msg.Loading("定位中...").then((loading)=>{
      that.map.getMaplocation(that.map_container.nativeElement).then(data=>{
        loading.dismiss();
        if(data.msg){
        }
        if(app.MARKER){//启用定位锚点
          that.getmendianlocation(data);
         }
      }).catch(error=>{  
        loading.dismiss();
          that.msg.Show(error.message,"top",true,3000);
      });
      loading.present();
    });
  // that.map.getMaplocation(that.map_container.nativeElement).then(data=>{
  //   console.log(data);
    
  // }).catch(error=>{  
  //   console.log(error);
  //      that.singInmsg = "定位失败,请联系管理员";
  //     that.msg.Show(error.message,"top",true,100000);
  // });
  //that.map.WalkingOptionLine(that.map_container.nativeElement,"");
 
}
getmendianlocation(data:any){
const that = this;
const maps = data.map;
that.config.forEach((ele)=>{
if(ele.type.toString()=="location"){
that.dataConfig = ele;
}
});
const PageName = that.activaRouter.snapshot.paramMap.get('ConfigName');
let body = new WebParameterContext();
body.ConfigName = that.dataConfig.selectItemList.gridViewConfigName;
body.OpType = "query";
body.ConfigType = "view";
body.RowsPerPage = 10;
body.Client.PageName = PageName;
body.Client.ApiType = "Element";
body.Client.Name = that.dataConfig.name;
body.Client.ClientType = 2;
if (that.platform.is("android")) {
  body.Client.ClientType = 0;
} else if (that.platform.is("ios")){
  body.Client.ClientType = 1;
}
body.RequestBody= JSON.stringify({"userId":that.com.GetAccount.Id,"longitude":data.position.lng,"latitude":data.position.lat});
that.msg.Loading("正在努力的查找附近门店...").then((load)=>{
  that.http.post(app.DEFAULTURL, body).then(data => {
    load.dismiss();
    if (data.ResponseMessage.Success) {
      that.childOuterEvent.emit(data.Status.Datas);
      if( data.Status.Datas.length>0){
        data.Status.Datas.forEach((items,index)=>{
          let objfield = {};
          that.dataConfig.selectItemList.selectItem.forEach((selectitem,indexs)=>{
            if(selectitem.bindingField && selectitem.field){
              objfield[selectitem.bindingField] = {"value":items[selectitem.field],"text":selectitem.text};
            }
          });
          // that.dataArrayList.push(objfield);
          that.baseService.ListData.push(objfield);
          // let marker= that.map.drawMarker(items.a_longitude,items.a_latitude,items.a_MenDian);
          //   maps.add(marker);
        });
      }
    }
  }).catch(error => {
    load.dismiss();
    that.msg.Show(error);
  });
  load.present();
}).catch((error)=>{
  console.log(error);
});
}

  EventLink(ev,item){
    console.log(item);
    if(item.isCheck){
      item.isCheck = false;
    }else{
      item.isCheck = true;
    }
   this.dataindex(this.baseService.ListData);
  }
  /**
   * 获取选中的数据源
   */
dataindex(dataArray:Array<any>){
  const that =this;
  let objarray:Array<any> = [];
  dataArray.forEach((items,index)=>{
    if(items.isCheck){
      objarray.push(items);
    }
  });
  that.baseService.arrayData=objarray;
}
}
